/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const availabilitySchemeSummarySchema = z.object({
  id: z.int(),
  isMembershipSynced: z.boolean(),
  name: z.string(),
});
